import {ready} from 'shared/utils';

const AUTO_ADVANCE_MS = 10000;

function showSlide(cards, dots, slideNum) {
  cards.forEach((card) => (card.style.display = 'none'));
  dots.forEach((dot) => dot.classList.remove('active'));
  cards[slideNum].style.display = 'block';
  dots[slideNum].classList.add('active');
}

ready(() => {
  const dots = [...document.querySelectorAll('.testimonial-dot')];
  const cards = [...document.querySelectorAll('.testimonial-card')];
  let current = 0;
  let timer = null;

  function advance() {
    clearInterval(timer);
    if (current < cards.length - 1) {
      timer = setInterval(() => {
        current++;
        showSlide(cards, dots, current);
        if (current >= cards.length - 1) clearInterval(timer);
      }, AUTO_ADVANCE_MS);
    }
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      current = index;
      showSlide(cards, dots, current);
      advance();
    });
  });

  advance();
});
